import ResourcesAPI from '../../api/ResourcesAPI';
import {
  GET_TAXES_REQUESTED,
  GET_TAXES_SUCCESS,
  DELETE_TAX_REQUESTED,
  ADD_TAX_REQUESTED,
  UPDATE_TAX_REQUESTED,
  GET_TAXED_LOCATIONS_REQUESTED,
  GET_TAXED_LOCATIONS_SUCCESS,
  GET_TAXED_PRODUCTS_REQUESTED,
  GET_TAXED_PRODUCTS_SUCCESS,
  GET_TAXED_CATEGORIES_REQUESTED,
  GET_TAXED_CATEGORIES_SUCCESS,
} from './TaxesActionTypes';
import {
  ERROR,
} from '../central/CentralActionTypes';

export function getTaxesSuccess(response) {
  return {
    type: GET_TAXES_SUCCESS,
    response,
  };
}

export function getTaxedLocationsSuccess(response) {
  return {
    type: GET_TAXED_LOCATIONS_SUCCESS,
    response,
  };
}

export function getTaxedProductsSuccess(response) {
  return {
    type: GET_TAXED_PRODUCTS_SUCCESS,
    response,
  };
}

export function getTaxedCategoriesSuccess(response) {
  return {
    type: GET_TAXED_CATEGORIES_SUCCESS,
    response,
  };
}

export function getTaxes(apiToken) {
  return (dispatch) => {
    dispatch({ type: GET_TAXES_REQUESTED });
    return ResourcesAPI.getAllResources(apiToken, ['taxes'])
      .then(response => dispatch(getTaxesSuccess(
        response.data,
      )),
      error => dispatch({
        type: ERROR,
        error,
      }));
  };
}

export function getTaxedLocations(apiToken, taxId) {
  return (dispatch) => {
    dispatch({ type: GET_TAXED_LOCATIONS_REQUESTED });
    return ResourcesAPI.getAllResources(apiToken, ['taxes', taxId, 'locations'])
      .then(response => dispatch(getTaxedLocationsSuccess(
        response.data,
      )),
      error => dispatch({
        type: ERROR,
        error,
      }));
  };
}

export function getTaxedProducts(apiToken, taxId) {
  return (dispatch) => {
    dispatch({ type: GET_TAXED_PRODUCTS_REQUESTED });
    return ResourcesAPI.getAllResources(apiToken, ['taxes', taxId, 'products'])
      .then(response => dispatch(getTaxedProductsSuccess(
        response.data,
      )),
      error => dispatch({
        type: ERROR,
        error,
      }));
  };
}

export function getTaxedCategories(apiToken, taxId) {
  return (dispatch) => {
    dispatch({ type: GET_TAXED_CATEGORIES_REQUESTED });
    return ResourcesAPI.getAllResources(apiToken, ['taxes', taxId, 'categories'])
      .then(response => dispatch(getTaxedCategoriesSuccess(
        response.data,
      )),
      error => dispatch({
        type: ERROR,
        error,
      }));
  };
}

export function deleteTax(apiToken, taxId) {
  return (dispatch) => {
    dispatch({ type: DELETE_TAX_REQUESTED });
    ResourcesAPI.deleteResource(apiToken, ['taxes', taxId])
      .then(
        () => dispatch(getTaxes(apiToken)),
        error => dispatch({
          type: ERROR,
          error,
        }),
      );
  };
}

export function addTax(apiToken, resource, ...resourcePath) {
  return (dispatch) => {
    dispatch({ type: ADD_TAX_REQUESTED });
    return ResourcesAPI.addResource(apiToken, resource, resourcePath)
      .then(
        () => dispatch(getTaxes(apiToken)),
        error => dispatch({
          type: ERROR,
          error,
        }),
      );
  };
}

export function updateTax(apiToken, newResource, ...resourcePath) {
  return (dispatch) => {
    dispatch({ type: UPDATE_TAX_REQUESTED });
    return ResourcesAPI.updateResource(apiToken, newResource, resourcePath)
      .then(
        () => dispatch(getTaxes(apiToken)),
        error => dispatch({
          type: ERROR,
          error,
        }),
      );
  };
}
